<template>
  <div class="wrapper">
    <!--    <button id="start-camera" @click="start_camera()">Start Camera</button>-->
    <video id="video" width="700" height="500" autoplay></video>
    <button id="click-photo" @click="click_photo()">گرفتن عکس</button>
    <canvas id="canvas" width="500" height="500"></canvas>
  </div>

</template>

<script>
import {bus} from "../../main";


export default {
  name: 'GalleryModals',
  props: {
    id: String,
  },
  data() {
    return {
      video: null,
      canvas: null,
    }
  }, mounted() {
    var self = this
    self.video = document.querySelector("#video");
    self.canvas = document.querySelector("#canvas");


    navigator.mediaDevices.getUserMedia({
      video: true,
      audio: false
    })
        // Upon success, stream video in a video tag.
        .then(function (stream) {
          self.video.srcObject = stream;
          self.video.play();
        })
        .catch(function (err) {
          console.log("An error occurred: " + err);
        });


  }, methods: {
    click_photo() {
      var self = this
      const videoRatio = self.video.videoWidth / self.video.videoHeight;
      const canvasRatio = self.canvas.width / self.canvas.height;
      let sx, sy, sWidth, sHeight;

      if (videoRatio > canvasRatio) {
        sHeight = self.video.videoHeight;
        sWidth = sHeight * canvasRatio;
        sx = (self.video.videoWidth - sWidth) / 2;
        sy = 0;
      } else {
        sWidth = self.video.videoWidth;
        sHeight = sWidth / canvasRatio;
        sx = 0;
        sy = (self.video.videoHeight - sHeight) / 2;
      }

      const ctx = self.canvas.getContext('2d');
      // رسم تصویر روی کانواس
      ctx.imageSmoothingQuality = 'high';
      // self.canvas.getContext('2d')
      ctx.drawImage(self.video, sx, sy, sWidth, sHeight, 0, 0, self.canvas.width, self.canvas.height);
    // .drawImage(self.video, 0, 0, 500, 500);
      let image_data_url = self.canvas.toDataURL('image/webp');
      bus.$emit(this.id, image_data_url)
      // data url of the image
      // console.log(image_data_url);
    },
    //   start_camera(){
    // var self = this
    //     let stream = await navigator.mediaDevices.getUserMedia({ video: true, audio: false });
    //     self.video.srcObject = stream;
    //   }
  },


}
</script>
<style>
#video {
  border: 1px solid black;
  width: 320px;
  height: 240px;
}

#photo {
  border: 1px solid black;
  width: 320px;
  height: 240px;
}

#canvas {
  display: none;
}

.camera {
  width: 340px;
  display: inline-block;
}

.output {
  width: 340px;
  display: inline-block;
}

#startbutton {
  display: block;
  position: relative;
  margin-left: auto;
  margin-right: auto;
  bottom: 36px;
  padding: 5px;
  background-color: #6a67ce;
  border: 1px solid rgba(255, 255, 255, 0.7);
  font-size: 14px;
  color: rgba(255, 255, 255, 1.0);
  cursor: pointer;
}

.contentarea {
  font-size: 16px;
  font-family: Arial;
  text-align: center;
}
</style>
